import axios from "../utils/axiosConfig";

const sectionService = {
    getAll: async (params = {}) => {
        try {
            const response = await axios.get("/sections", { params });
            return response.data;
        } catch (error) {
            console.warn("API Error, returning mock data", error);
        }
    },
    
    getById: async (id) => {
        try {
          const response = await axios.get(`/sections/${id}`);
          return response.data;
        } catch (error) {
            console.warn("API Error, returning mock data", error);
        }
    },

    create: async (data) => {
        return axios.post("/sections", data);
    },

    update: async (id, data) => {
        return axios.put(`/sections/${id}`, data);
    },

    delete: async (id) => {
        return axios.delete(`/sections/${id}`);
    },
};

export default sectionService;
